import Udesk from 'Udesk';
import Component from "./template";

export default Udesk.react.udeskify(Component);
